import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="magic-link-form"
export default class extends Controller {
  static targets = [
    'email',
    'rememberMe',
    'magicLinkForm',
  ]

  declare readonly emailTarget: HTMLInputElement
  declare readonly rememberMeTarget: HTMLInputElement
  declare readonly magicLinkFormTarget: HTMLFormElement

  submit (event: Event): void {
    event.preventDefault()

    // Get the email and remember me fields from the main form and dynamically create hidden fields in the magic link form
    // with the same values.
    const emailField = document.createElement('input')
    emailField.type = 'hidden'
    emailField.name = 'user[email]'
    emailField.value = this.emailTarget.value
    this.magicLinkFormTarget.appendChild(emailField)

    const rememberMeField = document.createElement('input')
    rememberMeField.type = 'hidden'
    rememberMeField.name = 'user[remember_me]'
    rememberMeField.value = this.rememberMeTarget.checked ? '1' : '0'
    this.magicLinkFormTarget.appendChild(rememberMeField)

    // Submit the magic link form
    this.magicLinkFormTarget.submit()
  }
}
